import Vue from "vue";
import Vuex from "vuex";
import step from "./modules/step";
import app from "./modules/app";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { step, app }
});
